(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/bet-events/assets/bet-event.js') >= 0) return;  svs.modules.push('/components/tipsen/bet-events/assets/bet-event.js');
"use strict";


const Participant = svs.components.tipsen.betEvents.Participant;
const BetEvent = _ref => {
  let className = _ref.className,
    _ref$awayParticipant = _ref.awayParticipant,
    awayParticipant = _ref$awayParticipant === void 0 ? {
      mediumName: 'Bortalag',
      name: 'Bortalag',
      flagISO: 'int'
    } : _ref$awayParticipant,
    _ref$homeParticipant = _ref.homeParticipant,
    homeParticipant = _ref$homeParticipant === void 0 ? {
      mediumName: 'Hemmalag',
      name: 'Hemmalag',
      flagISO: 'nir'
    } : _ref$homeParticipant,
    _ref$showMediumName = _ref.showMediumName,
    showMediumName = _ref$showMediumName === void 0 ? false : _ref$showMediumName;
  return React.createElement("li", {
    "aria-label": "".concat(homeParticipant.name, " mot ").concat(awayParticipant.name),
    className: ['pg_bet_event'].concat(className !== null && className !== void 0 ? className : []).join(' ')
  }, React.createElement(Participant, {
    flagISO: homeParticipant.flagISO,
    name: showMediumName ? homeParticipant.mediumName : homeParticipant.name
  }), React.createElement(Participant, {
    flagISO: awayParticipant.flagISO,
    name: showMediumName ? awayParticipant.mediumName : awayParticipant.name
  }));
};
setGlobal('svs.components.tipsen.betEvents.BetEvent', BetEvent);

 })(window);